var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-list"},[_c('div',{staticClass:"card-title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"card-content"},[_vm._t("default"),(!!_vm.$slots['footerButton'])?_c('div',{staticClass:"card-button border-light-top"},[_vm._t("footerButton")],2):_vm._e()],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }